//form constants
export const FORM_INPUT_TEXT_VALIDATE_ERROR = '入力に不備があります'
export const FORM_INPUT_TEXT_VALIDATE_NECESSALY = '入力必須項目です'
export const FORM_INPUT_TEXT_VALIDATE_EMAIL_FORMAT = 'メールアドレスが不正です'
export const FORM_INPUT_TEXT_VALIDATE_EMAIL = 'このメールアドレスは当サイトではご利用いただけません'
export const FORM_INPUT_TEXT_VALIDATE_TEL = '電話番号が不正です'
